import { Input, InputRef, Tooltip } from 'antd';
import { useRef, useState } from 'react';

const EditableText = ({
  value,
  onChange,
  renderText,
  inputPlaceholder,
}: {
  value: string;
  onChange: (newValue: string) => void;
  renderText: (value: string, onClick: () => void) => React.ReactNode;
  inputPlaceholder?: string;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);

  const handleInputFocus = () => {
    setIsEditing(true);
    setTimeout(() => inputRef?.current?.focus() || null, 100);
  };

  return (
    <Tooltip title={isEditing ? 'Click outside to Save' : 'Click to Edit'}>
      <div tabIndex={0} onFocus={handleInputFocus}>
        {!isEditing ? (
          renderText(value, handleInputFocus)
        ) : (
          <Input
            ref={inputRef as React.LegacyRef<InputRef>}
            onBlur={() => setIsEditing(false)}
            onChange={(e) => onChange(e.target.value)}
            value={value}
            placeholder={inputPlaceholder}
          />
        )}
      </div>
    </Tooltip>
  );
};

export default EditableText;
